export const creatingStates = {
  UPLOADING_IMAGE: 1,
  UPLOAD_COMPLETE: 2,
}